import {
    UPDATE_VIEWED_LOCATION,
    TOGGLE_NAV,
    TOGGLE_CONTACT
} from '../constants'


export const toggleNav = (bool) => ({ type: TOGGLE_NAV, bool })

export const toggleContact = (bool, contactType) => ({ type: TOGGLE_CONTACT, bool, contactType })

export const updateLocationCell = (index) => ({ type: UPDATE_VIEWED_LOCATION, index })